export default __webpack_public_path__ + "static/media/icon-fork-dark.c781d8a8.svg";